export const imgTypes = ['.jpg', '.jpeg', '.png', '.webp'];
export const textTypes = ['.css', '.js'];
export const videoTypes = ['.mp4'];
export const allowConvert2Webp = [...imgTypes, '.svg', '.gif', '.tiff', '.tif', '.avif', '.gif', '.heic', '.hevc'];
export const allowEditMenuItem = [...imgTypes, ...textTypes];

 